<script lang="ts">
    import CategorySelection from '$lib/components/navigation/CategorySelection.svelte';
    import LanguageSelection from '$lib/components/navigation/LanguageSelection.svelte';
    import Quotes from '$lib/components/navigation/Quotes.svelte';
    import { t } from 'svelte-i18n';

    export let dropdownActive = false;
    export let cartSideBarOpen = false;

    function toggleDropdown() {
        if (!dropdownActive) cartSideBarOpen = false;
        dropdownActive = !dropdownActive;
    }
</script>

<svelte:window
    on:scroll={() => {
        if (dropdownActive) dropdownActive = false;
    }}
/>

<button
    on:click={toggleDropdown}
    class="size-10 border border-primary lg:mr-4 flex items-center justify-center bg-black hover:bg-primary transition-colors group"
>
    <div class="flex flex-col {dropdownActive ? 'gap-[4px]' : 'gap-[5px]'}">
        <div
            class="w-[17px] h-[1px] bg-primary origin-center {dropdownActive
                ? 'rotate-45 translate-y-[5px] '
                : ''}  group-hover:bg-black transition-all"
        />
        <div
            class="w-[17px] h-[1px] bg-primary {dropdownActive ? 'opacity-0' : ''} group-hover:bg-black transition-all"
        />
        <div
            class="w-[17px] h-[1px] bg-primary origin-center {dropdownActive
                ? '-rotate-45 -translate-y-[5px] '
                : ''} group-hover:bg-black transition-all"
        />
    </div>
</button>

<div
    class="{dropdownActive
        ? 'opacity-100'
        : 'opacity-0 pointer-events-none'} border-t lg:border-none border-neutral-700 transition-opacity duration-300 max-h-[calc(100vh-64px)] overflow-y-auto lg:h-auto flex justify-center absolute tracking-widest w-full top-[122px] lg:top-[4.125rem] left-0 bg-black z-40 pt-12 pb-24 lg:pt-14 lg:pb-16 text-sm text-neutral-400"
>
    <div
        class="{dropdownActive
            ? 'translate-y-0'
            : 'translate-y-8'} transition-all duration-300 max-w-screen-2xl h-fit lg:h-full w-full gap-12 flex flex-col lg:flex-row justify-between px-5"
    >
        <CategorySelection bind:dropdownActive />
        <Quotes />
        <div class="order-2 lg:order-3 flex flex-col gap-12">
            <!-- Contact Section -->
            <div class="flex flex-col gap-2">
                <h2 class="font-cinzel uppercase text-sm text-primary">
                    {$t('shop.navigation.dropdown.contactSection.title')}
                </h2>
                <p class="uppercase font-bold">{$t('shop.navigation.dropdown.contactSection.companyName')}</p>
                <p>{$t('shop.navigation.dropdown.contactSection.addressLine1')}</p>
                <p>{$t('shop.navigation.dropdown.contactSection.addressLine2')}</p>
                <a href="tel:+496501802290" class="sm:hover:text-offwhite transition-colors">
                    <span class="text-bold text-primary">T</span>
                    {$t('shop.navigation.dropdown.contactSection.phoneNumber')}
                </a>
                <a href="mailto:office@vanvolxem.com" class="sm:hover:text-offwhite transition-colors">
                    <span class="text-bold text-primary">E</span>
                    {$t('shop.navigation.dropdown.contactSection.emailAddress')}
                </a>
            </div>

            <!-- Opening Hours Section -->
            <div class="flex flex-col gap-2">
                <h2 class="font-cinzel uppercase text-sm text-primary">
                    {$t('shop.navigation.dropdown.openingHours.title')}
                </h2>
                <p class="uppercase font-bold">{$t('shop.navigation.dropdown.openingHours.sectionTitle')}</p>
                <p>{$t('shop.navigation.dropdown.openingHours.days')}</p>
                <p>{$t('shop.navigation.dropdown.openingHours.hours')}</p>
            </div>

            <!-- Language Selection Section -->
            <div class="flex flex-col gap-2">
                <h2 class="font-cinzel uppercase text-primary">
                    {$t('shop.navigation.dropdown.languageSelection.title')}
                </h2>
                <LanguageSelection />
            </div>
        </div>
    </div>
</div>
<!--<button
        transition:fade={{ duration: 300 }}
        class="absolute bg-black/50 top-0 -left-5 lg:left-0 -z-10 w-screen h-screen"
        on:click={toggleDropdown}
    ></button>-->
